import React from "react";
import { useHistory } from "react-router-dom";
import {
    Container,
    Button,
    Grid,
    Backdrop,
    CircularProgress,
    MenuItem,
    useTheme,
    LinearProgress,
} from "@material-ui/core";
import moment from "moment";
import { DateTimePicker } from "formik-material-ui-pickers";

import { useMeasurementsDispositions } from "../../../common/services/dispositionServices";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { useUsers } from "../../../common/CommonQueries";
import { useStressTypes } from "./stressEntryQueries";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import measurementSubmission from "../../../testCommunication/common/measurementSubmission";
import { useSubmitMeasurementResult, useSubmitProcedureResult, useSubmitStepResult } from "../../../testCommunication/common/testMutations";
import { useFetchContext } from "../../../common/FetchContext";
import { useAuthContext } from "../../../common/AuthContext";
import TesterTypes from "../../../testCommunication/common/TesterTypes";
import { TextField } from "formik-material-ui";
import { toast } from "react-toastify";
import { set } from "lodash";
import { useProcedureResult, useTestCommunicationDetails } from "../../../testCommunication/common/testQueries";
import { start } from "repl";
import { useQueryClient } from "react-query";

export const IamPanFields = ({
    historicUser,
    setHistoricUser,
    historicDate,
    assetData,
    procedureResultData,
    closeHistoricModal,
    showSuccessToast,
    historicData,
    setHistoricDate,
    historicDisposition,
    setHistoricDisposition,
}: any) => {
    const theme = useTheme();
    const history = useHistory();
    const { mutateAsync: mutateSubmitMeasurementResult } =
        useSubmitMeasurementResult();
    const { mutateAsync: mutateSubmitStepResult } = useSubmitStepResult();
    const { mutateAsync: mutateSubmitProcedureResult } =
        useSubmitProcedureResult();
    const { authAxios } = useFetchContext();
    const { dispatch } = useAuthContext();
    const [submissionStatus, setSubmissionStatus] = React.useState(false);

  const queryClient = useQueryClient();



    const {
        data: assets,
        error: errorStresses,
        isLoading: isLoadingStresses,
        isError: isErrorStresses,
    } = useTestCommunicationDetails("iv_curve");

    const {
        data: users,
        isError: isErrorUsers,
        isLoading: isLoadingUsers,
        error: errorUsers,
    } = useUsers();
    const {
        data: dispositions,
        isError: isErrorDispositions,
        isLoading: isLoadingDispositions,
        error: errorDispositions,
    } = useMeasurementsDispositions();

    if (isLoadingUsers || isLoadingDispositions || submissionStatus) {
        return (
           <LinearProgress></LinearProgress>
        );
    }

    if (isErrorUsers) {
        return <ErrorMessage error={errorUsers} />;
    }

    if (isErrorDispositions) {
        return <ErrorMessage error={errorDispositions} />;
    }

    return (
        <Formik
            initialValues={{
                asset: "",
                user: "",
                disposition: "",
                startDate: null,
                endDate: null,
            }}
            validationSchema={Yup.object({
                asset: Yup.string().required("Field must be required"),
                user: Yup.string().required("Field must be required"),
                disposition: Yup.string().required("Field must be required"),
                startDate: Yup.date().required("Field must be required"),
                endDate: Yup.date().required("Field must be required"),

            })}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
                setSubmitting(true);
                setSubmissionStatus(true);
                setHistoricUser(values.user);
                setHistoricDate(moment(values.startDate).format("YYYY-MM-DD HH:mm:ss"));
                // If you need to update assetData, use a setter like setAssetData(values.asset)

                assetData = values.asset;
                console.log("IamPanFields values", JSON.stringify(assetData, null, 2));



                for (let stepResult of procedureResultData.step_results) {


                    for (let measurementResult of stepResult.measurement_results) {

                        await mutateSubmitMeasurementResult({
                            authAxios,
                            user: values.user,
                            date_time: values.startDate,
                            start_datetime: values.startDate,
                            end_datetime: values.endDate,
                            historic: true,
                            disposition: values.disposition,
                            asset: values.asset,
                            measurementResultId: measurementResult.id,
                        });

                    }

                    await mutateSubmitStepResult({
                        authAxios,
                        disposition: values.disposition,
                        start_datetime: values.startDate,
                        stepResultId: stepResult.id,
                    });

                }

                await mutateSubmitProcedureResult({
                    authAxios,
                    disposition: values.disposition,
                    start_datetime: values.startDate,
                    end_datetime: values.endDate,
                    procedureResultId: procedureResultData.id,
                });

                setSubmissionStatus(false)
                toast.success("Test successfully submitted")

                if (closeHistoricModal) {
                    closeHistoricModal();
                }
                queryClient.invalidateQueries("travelerResults");

            }}
        >
            {({
                errors,
                touched,
                submitForm,
                setFieldValue,
                initialValues,
                values,
            }) => {

                return (
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="flex-start"
                        spacing={2}
                    >
                        <Grid item xs={4}>
                            <Field
                                id="asset"
                                type="text"
                                name="asset"
                                select={true}
                                fullWidth
                                component={TextField}
                                helperText={touched.asset ? errors.asset : null}
                                error={touched.asset && Boolean(errors.asset)}
                                style={{ marginBottom: 32 }}
                                label="Asset"
                                data-testid="assetId"
                            >
                                {assets.assets?.map((asset: any) => (
                                    <MenuItem key={asset.id} value={asset.id}>
                                        {asset.name}
                                    </MenuItem>
                                ))}
                            </Field>





                        </Grid>
                        <Grid item xs={4}>

                            <Field
                                id="user"
                                type="text"
                                name="user"
                                select={true}
                                fullWidth
                                component={TextField}
                                helperText={touched.user ? errors.user : null}
                                error={touched.user && Boolean(errors.user)}
                                style={{ marginBottom: 32 }}
                                label="User"
                                data-testid="userId"
                            >
                                {users?.map((user: any) => (
                                    <MenuItem
                                        key={user.id}
                                        value={user.id}
                                    >
                                        {user.username}
                                    </MenuItem>
                                ))}
                            </Field>


                        </Grid>
                        <Grid item xs={4}>

                            <Field
                                id="disposition"
                                type="text"
                                name="disposition"
                                select={true}
                                fullWidth
                                component={TextField}
                                helperText={touched.disposition ? errors.disposition : null}
                                error={touched.disposition && Boolean(errors.disposition)}
                                style={{ marginBottom: 32 }}
                                label="Disposition"
                                data-testid="dispositionId"
                            >
                                {dispositions?.map((disposition: any) => (
                                    <MenuItem
                                        key={disposition.id}
                                        value={disposition.id}
                                    >
                                        {disposition.name}
                                    </MenuItem>
                                ))}
                            </Field>

                        </Grid>
                        <Grid item xs={4}>
                            <Field
                                name="startDate"
                                component={DateTimePicker}
                                format="YYYY-MM-DD HH:mm:ss"
                                style={{ marginBottom: 32 }}
                                label="Start Date"
                                inputVariant="outlined"
                                data-testid="startDateId"
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Field
                                name="endDate"
                                component={DateTimePicker}
                                format="YYYY-MM-DD HH:mm:ss"
                                style={{ marginBottom: 32 }}
                                label="End Date"
                                inputVariant="outlined"
                                data-testid="endDateId"
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Button
                                color="primary"
                                disabled={submissionStatus}
                                variant="contained"
                                style={theme.btnSubmit}
                                fullWidth
                                onClick={() => submitForm()}
                            >
                                Save Measurement
                            </Button>
                        </Grid>
                    </Grid>
                );
            }}
        </Formik>
    )
};
